import elementExists from "../utils/elementExists"

const Glossary = function(){
    const container = document.querySelector('#glossary-items')
    if( elementExists( container )){
        let rows = container.querySelectorAll( '.glossary-item');
        if( elementExists( rows, true )){
            rows = Array.prototype.slice.call(rows, 0);
            rows.sort(function (a, b) {
                if( a.id < b.id ) return -1
                if( a.id > b.id ) return 1
                return 0
            });
            container.innerHTML = '';
            rows.forEach( row => {
                container.appendChild(row);
            })
            // container.innerHTML = rows.map( row => {
            //     return row.innerHTML;
            // }).toString();
        }
    }

}

export default Glossary